export default __webpack_public_path__ + "static/media/plus.0e1c29cd.svg";